import React, { useState } from 'react'
import ExpiredInstrumentsListItem from './ExpiredInstrumentsListItem'

const ExpiredInstrumentsList = props => {
  const { expiredInstruments = [] } = props

  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <div className='expired-instruments'>
      <div className='expired-instruments-title-box'>
        <div className='expired-instruments-title'>Expired instruments</div>
        <div
          className='expired-instruments-expand-btn'
          onClick={() => setIsExpanded(!isExpanded)}>
          <i
            className={isExpanded ? 'fa fa-chevron-up' : 'fa fa-chevron-down'}
          />
        </div>
      </div>
      {isExpanded ? (
        <div className='expired-instruments-list'>
          {expiredInstruments.map(expiredInstrument => {
            return (
              <ExpiredInstrumentsListItem
                key={expiredInstrument.id || expiredInstrument.instrument_id}
                expiredInstrument={expiredInstrument}
              />
            )
          })}
        </div>
      ) : null}
    </div>
  )
}

export default ExpiredInstrumentsList
